import styled, { css } from 'styled-components';
import { theme } from '../../styled/layout/theme';
import Typography from '.';

export type BodySize = 'sm' | 'md' | 'lg';

export interface IBody {
  $size?: BodySize;
  $sizeMobile?: BodySize;
  $as?: React.ElementType;
}

export const sizeStyles = {
  sm: css`
    font-size: var(--mio-font-size-body-sm);
    letter-spacing: var(--mio-font-letter-spacing-body-sm);
    line-height: var(--mio-font-line-height-body-sm);
  `,
  md: css`
    font-size: var(--mio-font-size-body-md);
    letter-spacing: var(--mio-font-letter-spacing-body-md);
    line-height: var(--mio-font-line-height-body-md);
  `,
  lg: css`
    font-size: var(--mio-font-size-body-lg);
    letter-spacing: var(--mio-font-letter-spacing-body-lg);
    line-height: var(--mio-font-line-height-body-lg);
  `,
};

export const Body = styled(Typography)<IBody>`
  font-family: var(--mio-font-family-body, sans-serif);
  margin: 0;
  padding: 0;

  ${({ $size = 'md' }) => sizeStyles[$size]}

  ${theme.screens.LtMd} {
    ${({ $size = 'md', $sizeMobile }) => sizeStyles[$sizeMobile ?? $size]}
  }
`;

export default Body;
